import { inject, Injectable } from '@angular/core';
import { DbService } from '../db/db.service';
import { AuthService } from '../auth/auth.service';
import { Project } from '../../models/project';
interface CounterDoc {
	currentValue: number;
}
@Injectable({
	providedIn: 'root'
})
export class UniqueIdService {
	private db = inject(DbService);
	private authService = inject(AuthService);

	// async generateAndSave(): Promise<string> {
	// 	let newID: string;
	// 	let doc: any;

	// 	do {
	// 		newID = (Math.floor(100000 + Math.random() * 900000)).toString();
	// 		doc = await this.db.getProyIdRef(this.authService.projectId).collection('ids').doc(newID).get();
	// 	} while (doc.exists);

	// 	await this.db.firestore.collection(Project.PATH).doc(this.authService.projectId).collection('ids').doc(newID).set({ id: newID });

	// 	return newID;
	// }

	async delete(id: string): Promise<void> {
		await this.db.getProyIdRef(this.authService.projectId).collection('ids').doc(id).delete();
	}

	async getOrCreateNextNumericId(collectionName: string, collectionDoc: string, startValue: number): Promise<string> {
		const counterRef = this.db.getProyIdRef(this.authService.projectId)
			.collection(collectionName)
			.doc(collectionDoc);

		// Run a transaction to ensure the counter is initialized and incremented atomically
		const newID = await this.db.firestore.runTransaction(async (transaction) => {
			const counterDoc = await transaction.get(counterRef);

			let currentValue = startValue;
			if (counterDoc.exists) {
				// Increment the existing counter
				const data = counterDoc.data() as CounterDoc;
				// Increment the existing counter
				currentValue = data.currentValue + 1;
			}

			// Update or initialize the counter in Firestore
			transaction.set(counterRef, { currentValue });

			return currentValue.toString();
		});

		return newID;
	}
}
